<script setup lang="ts">
  import { ref } from 'vue';
  import type { AccountUser } from '@/features/account';
  import type { DestinationPrices } from '@/features/searchForm/destination';
  import { SerpLayout, useSerpCriteria } from '@/layouts/serp';
  import { CountryResortsUrl, FormDataUrl, IntelligentSearchUrl } from '@/shared/config/formData';
  import { SearchForm, type SearchFormCriteria, type SearchFormExpose } from '@/widgets/searchForm';

  // Повторяет SerpPageProps из layouts/serp: compiler-sfc Vue 2.7 не резолвит импортированный
  // тип в defineProps, поэтому контракт страницы объявлен здесь.
  interface HotelsSearchProps {
    modelValue?: SearchFormCriteria | null;
    user?: AccountUser | null;
    accountUrl?: string;
    prices?: DestinationPrices;
    departureDisabled?: boolean;
    destinationDisabled?: boolean;
  }

  const props = withDefaults(defineProps<HotelsSearchProps>(), {
    modelValue: null,
  });

  interface HotelsSearchEmits {
    (e: 'update:modelValue', criteria: SearchFormCriteria): void;
    (e: 'search', criteria: SearchFormCriteria): void;
    (e: 'login'): void;
    (e: 'logout'): void;
    (e: 'buy'): void;
  }
  const emit = defineEmits<HotelsSearchEmits>();

  const searchFormRef = ref<SearchFormExpose | null>(null);
  const criteria = useSerpCriteria(props, emit);

  defineExpose<SearchFormExpose>({
    validate: () => (searchFormRef.value ? searchFormRef.value.validate() : true),
    submit: () => searchFormRef.value?.submit(),
    reset: () => searchFormRef.value?.reset(),
  });
</script>

<script lang="ts">
  export default {
    model: {
      prop: 'modelValue',
      event: 'update:modelValue',
    },
  };
</script>

<template>
  <SerpLayout
    :user="user"
    :accountUrl="accountUrl"
    @login="emit('login')"
    @logout="emit('logout')"
    @buy="emit('buy')"
  >
    <template #form="{ collapsed }">
      <SearchForm
        ref="searchFormRef"
        v-model="criteria"
        :roundedBottom="collapsed"
        :prices="prices"
        :isVisibleDeparture="false"
        dateFieldLabel="Дата заезда"
        touristsFieldLabel="Гости"
        nightsSummaryPrefix="С"
        searchBtnText="Найти отели"
        :isVisibleRoomButton="false"
        :departureDisabled="departureDisabled"
        :destinationDisabled="destinationDisabled"
        :formUrl="FormDataUrl.Hotels"
        :searchUrl="IntelligentSearchUrl.Hotels"
        :resortsUrl="CountryResortsUrl.Hotels"
        @search="emit('search', $event)"
      />
    </template>
  </SerpLayout>
</template>
